import { render, staticRenderFns } from "./ApplicationAccess.vue?vue&type=template&id=2a6ee4b4&scoped=true"
import script from "./ApplicationAccess.vue?vue&type=script&lang=js"
export * from "./ApplicationAccess.vue?vue&type=script&lang=js"
import style0 from "./ApplicationAccess.vue?vue&type=style&index=0&id=2a6ee4b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ee4b4",
  null
  
)

export default component.exports